import { createBrowserHistory as createOriginalBrowserHistory } from 'history';

import { extendHistory } from '../extendHistory';
import { buildClientHistory } from './buildClientHistory';
import type { GetNavigationMethod } from '../buildHistory';

type CreateBrowserHistoryOptions = Parameters<typeof createOriginalBrowserHistory>[0] & {
    getNavigationMethod?: GetNavigationMethod;
};

export function createBrowserHistory({ getNavigationMethod, ...originalOptions }: CreateBrowserHistoryOptions = {}) {
    return buildClientHistory(
        extendHistory(createOriginalBrowserHistory(originalOptions), {
            getNavigationMethod,
        })
    );
}
